export default __webpack_public_path__ + "static/798-564ef7d10d1685a9c14b0ec0f00fc3de.gif";